import { ACTION, ROLE } from '@talos/kyoko';
import { useFeatureFlag, useRoleAuth } from '../../../hooks';

export function useTradingControlsAccountSegregationBypass() {
  const { bypassAccountSegregationChecksForTradingControlsSettings } = useFeatureFlag();
  const { isAuthorized, isRole } = useRoleAuth();

  return (
    isAuthorized(ACTION.VIEW_ALL_MARKET_ACCOUNTS_IN_TRADING_CONTROLS) ||
    (bypassAccountSegregationChecksForTradingControlsSettings &&
      (isRole(ROLE.TRADING_CONFIG) || isRole(ROLE.TRADING_CONTROLS_ADMIN)))
  );
}
